import { useMediaQuery } from '@material-ui/core';
import { AddExtraSeatsCorporatePremiumForm } from 'model/forms/AddExtraSeatsCorporatePremium';
import React, { FC, useCallback } from 'react';
import { from } from 'styles/mixins';
import { up } from 'utils/Paths';
import connect from './connect';
import Form from './Form';
import { Container, Content, Paragraph, Title } from './styles';
import { Props } from './types';

const AddExtraSeatsModal: FC<Props> = ({
  history: { push },
  info,
  match,
  addExtraSeats,
}) => {
  const url = match?.url;
  const isFromTablet = useMediaQuery(from.mobileXL.query);

  const onClose = useCallback(() => {
    if (url) {
      push({
        pathname: up(url),
        state: {
          scrollToTop: false,
        },
      });
    }
  }, [push, url]);

  const onSubmit = useCallback(
    (value: AddExtraSeatsCorporatePremiumForm) => {
      const currentSeats = info?.quantity ?? 1;
      const extraSeats = Number(value.totalUsers);
      const totalUsers = currentSeats + extraSeats;
      addExtraSeats({ totalUsers });
    },
    [addExtraSeats, info],
  );

  return (
    <Container
      animation="slideUp"
      fullScreen={!isFromTablet}
      onClose={onClose}
      open={!!url}
      scroll="body"
    >
      <Content>
        <Title>Add Extra Seats</Title>
        <Paragraph>
          You currently have 0 seats available on your account.
        </Paragraph>
        <Form
          onSubmit={onSubmit}
          planAmountPerMonth={info?.plan?.amount ? info.plan.amount / 100 : 0}
          planInterval={info?.plan?.interval}
          quantity={info?.quantity}
        />
      </Content>
    </Container>
  );
};

export default connect(AddExtraSeatsModal);
